export default __webpack_public_path__ + "static/media/nft5.35e7faff.jpg";